import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { createTrackableProps } from "@xo-union/tk-component-analytics";
import { Subhead, Editorial, Body2, Overline } from "@xo-union/tk-ui-typography";
import Icon from "@xo-union/tk-component-icons";
import { NewWindowAnchor } from "@xo-union/component-standard-elements";
import ChatSection from "../sections/ChatSection/index.js";
import { AppleStoreBadge, GooglePlayBadge, QrCode } from "../graphicElements/index.js";
import styles from "../../../../css/index.css";
const AppDownload = () => /*#__PURE__*/React.createElement("div", {
  className: styles.appDownload
}, /*#__PURE__*/React.createElement(Subhead, {
  bold: true,
  as: "div"
}, "One free app for everything wedding planning."), /*#__PURE__*/React.createElement("div", {
  className: styles.appContainer
}, /*#__PURE__*/React.createElement("div", {
  className: styles.qrCodeContainer
}, /*#__PURE__*/React.createElement(QrCode, {
  className: styles.qrCode
}), /*#__PURE__*/React.createElement(Overline, {
  as: "span"
}, "Get the app")), /*#__PURE__*/React.createElement("div", {
  className: styles.storeBadgeContainer
}, /*#__PURE__*/React.createElement(AppleStoreBadge, _extends({
  className: styles.storeBadge,
  "aria-label": "Download on the Apple store"
}, createTrackableProps({
  selection: 'app-store'
}))), /*#__PURE__*/React.createElement(GooglePlayBadge, _extends({
  className: styles.storeBadge,
  "aria-label": "Get it on Google play"
}, createTrackableProps({
  selection: 'google-play'
}))))), /*#__PURE__*/React.createElement(Editorial, {
  bold: true,
  as: "div",
  className: styles.areYouVendorHeader
}, "Are you a vendor?"), /*#__PURE__*/React.createElement(Body2, null, "Sign up on The Knot to reach more couples and book more weddings!"), /*#__PURE__*/React.createElement(Body2, _extends({
  bold: true,
  as: NewWindowAnchor,
  href: "https://vendors.theknot.com/vendors-advertising-dr?itm_source=theknot.com&itm_medium=referral&itm_campaign=footer-nav",
  className: styles.areYouVendorLink
}, createTrackableProps({
  selection: 'are-you-a-vendor'
})), "Start here ", /*#__PURE__*/React.createElement(Icon, {
  name: "forward",
  size: "sm"
})), /*#__PURE__*/React.createElement(ChatSection, {
  hideInDesktop: true
}));
export default AppDownload;